import React from 'react';
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface ToastProps {
  message: string;
  onClose?: () => void;
  persistent?: boolean;
}

const Toast: React.FC<ToastProps> = ({ message, onClose, persistent }) => {
  return (
    <div className="fixed top-4 left-0 right-0 z-[60] flex justify-center pointer-events-none">
      <div className="w-[calc(100%-2rem)] max-w-sm rounded-2xl border border-claude-border/60 dark:border-claude-darkBorder/60 bg-white/95 dark:bg-claude-darkSurface/95 text-claude-text dark:text-claude-darkText px-4 md:px-6 py-4 shadow-xl backdrop-blur-md animate-scale-in pointer-events-auto">
        <div className="flex items-center gap-4">
          <div className="shrink-0 rounded-full bg-claude-accent/10 p-2.5">
            <InformationCircleIcon className="h-5 w-5 text-claude-accent" />
          </div>
          <div className="flex-1 text-base font-semibold leading-none">
            {message}
          </div>
          {persistent && onClose && (
            <button
              type="button"
              onClick={onClose}
              className="shrink-0 rounded-full p-1 text-claude-textMuted hover:bg-claude-border/40 dark:hover:bg-claude-darkBorder/40"
              aria-label="close"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Toast;
